export default async function focusLastActivePanel ({ commit, state, getters }) {
  const lastPanelId = getters.getLastActivePanelId()

  if (state.activePanelId !== null) {
    commit('SET_ACTIVE_PANEL_ID', null)
  }
  commit('SET_ACTIVE_PANEL_ID', lastPanelId)
}
